// smooth page navigation scrolling

jQuery(document).ready(function($) {

    $('.smooth-scroll').click( function(event) {
        var anchorLink = $( this );
        var targetSection = $( anchorLink.attr('href') );
        var offset = 0;

        var $mobileHeader = $( '.site-header--mobile' );

        // if the mobile header is showing, use the height of that as the offset (so scroll doesn't cut it off)
		if ( $mobileHeader.css( 'display' ) != 'none' ) {
	        offset = $mobileHeader.outerHeight();
	    } else {
	    	// otherwise, we're on mobile so use the height of the desktop nav as the offset
	    	offset = $( '.nav-item' ).first().outerHeight();
	    }

        var scrollTo = targetSection.offset().top - offset;

        $('html, body').stop().animate({
            scrollTop: scrollTo
        }, 800 );

        event.preventDefault();
    });

});